import BaseService from '../baseServices';
import REST from '../../configs/rest';

function getNotifications() {
  return BaseService.get(REST.NOTIFICATIONS);
}

export default {
  getNotifications,
};
